/**
 * IBAN Helper Utilities
 * Formatting, validation, and bank lookup
 */

/**
 * Format IBAN with spaces (DE12 1234 5678...)
 */
export const formatIBAN = (iban) => {
  if (!iban) return '';
  
  // Remove all spaces and convert to uppercase
  const cleaned = iban.replace(/\s/g, '').toUpperCase();
  
  // Add space every 4 characters
  return cleaned.match(/.{1,4}/g)?.join(' ') || cleaned;
};

/**
 * Clean IBAN (remove spaces)
 */
export const cleanIBAN = (iban) => {
  if (!iban) return '';
  return iban.replace(/\s/g, '').toUpperCase();
};

/**
 * Basic IBAN validation (length check)
 */
export const isValidIBANLength = (iban) => {
  const cleaned = cleanIBAN(iban);
  return cleaned.length >= 15 && cleaned.length <= 34;
};

/**
 * Lookup bank details via API
 */
export const lookupBankDetails = async (iban, apiUrl) => {
  try {
    const response = await fetch(`${apiUrl}/api/affiliate/validate-iban`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ iban: cleanIBAN(iban) }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Bank lookup error:', error);
    return {
      valid: false,
      message: 'Bank-Lookup fehlgeschlagen',
    };
  }
};

/**
 * Get country name from IBAN country code
 */
export const getCountryName = (countryCode) => {
  const countries = {
    'DE': 'Deutschland',
    'AT': 'Österreich',
    'CH': 'Schweiz',
    'FR': 'Frankreich',
    'IT': 'Italien',
    'ES': 'Spanien',
    'NL': 'Niederlande',
    'BE': 'Belgien',
    'LU': 'Luxemburg',
    'PL': 'Polen',
    'CZ': 'Tschechien',
  };
  
  return countries[countryCode] || countryCode;
};
